export const tasks: Task[] = ['TRANSCRIBE', 'VERIFY', 'READ'];

export const taskFilterMap = {
	TRANSCRIBE: 'status = "unprocessed" OR status = "incomplete"',
	VERIFY: 'status = "completed"',
	READ: 'status = "approved"',
} as const;

export const statusFilterMap = {
	UNPROCESSED: '(status = "unprocessed" OR status = "incomplete")',
	INCOMPLETE: '(status = "unprocessed" OR status = "incomplete")',
	COMPLETED: 'status = "completed"',
	APPROVED: 'status = "approved"',
} as const;

export const filterUser = (task: string, userId: string) => {
	if (task === 'TRANSCRIBE') {
		return `latestSubmissionUserId != "${userId}"`;
	}
	if (task === 'VERIFY') {
		return `latestSubmissionUserId != "${userId}" AND latestApprovalsUserIds != "${userId}"`;
	}
};

export const statusMap = {
	UNPROCESSED: 'Erfassen',
	LOCKED: 'Erfassen',
	INCOMPLETE: 'Erfassen',
	COMPLETED: 'Prüfen',
	APPROVED: 'Ansehen',
} as const;
